(() => {
  const init = () => {
    document.querySelectorAll('[data-customsirge-quantity-tiles]').forEach((wrap) => {
      const section = wrap.closest('[data-section-id]') || document;
      const tiles = Array.from(wrap.querySelectorAll('[data-customsirge-quantity-tile]'));
      if (!tiles.length) return;

      const findInput = () => section.querySelector('.customsirge-quantity-and-buy__input');

      const setActive = (qty) => {
        const numeric = Number(qty);
        tiles.forEach((tile) => {
          if (Number(tile.dataset.quantity) === numeric) {
            tile.setAttribute('data-active', 'true');
          } else {
            tile.removeAttribute('data-active');
          }
        });
      };

      tiles.forEach((tile) => {
        tile.addEventListener('click', () => {
          const input = findInput();
          if (!input) return;
          const qty = Number(tile.dataset.quantity);
          input.value = qty;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          setActive(qty);
        });
      });

      const input = findInput();
      if (input) {
        setActive(input.value);
        input.addEventListener('change', () => setActive(input.value));
        input.addEventListener('input', () => setActive(input.value));
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
